export default __webpack_public_path__ + "static/media/ambiente.577bf001.jpg";